import React, { FC, HTMLAttributes } from "react";
// import { useSelector } from "react-redux";
// import { RootState } from "../../Redux/Reducers";

interface PageLoaderProps extends HTMLAttributes<HTMLDivElement> {
  show: boolean;
  customStyles?: React.CSSProperties;
}

const PageLoader: FC<PageLoaderProps> = (props): React.JSX.Element | null => {
  return (
    <h1>Loading....</h1>
  )
  // const { customStyles = {} } = props;
  // const { pageLoaderVisibility } = useSelector((state: RootState) => state.commonReducer);
  // if (!props.show) return null;

  // return pageLoaderVisibility ? (
  //   <div className="">Loading....</div>
  //   // <div
  //   //   className="aspect-ratio--object flex justify-center items-center-ns bg-black-60"
  //   //   style={{ zIndex: 1000, ...customStyles }}
  //   // >
  //   //   <span>
  //   //     <img className="img h3" src={SpinnerIcon} />
  //   //   </span>
  //   // </div>
  // ) : null;
};

export default PageLoader;
